export const SHARE_TAB_PARAM = "tab";
export enum ShareTabType {
  Approved = "approved",
  Pending = "pending",
}
